var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query.shows,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "shows", $$v);
      },
      expression: "query.shows"
    }
  }, 'v-select', Object.assign({}, _vm.$attrs, {
    items: _vm.items
  }), false));
}
var staticRenderFns = []

export { render, staticRenderFns }